document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.customizer-upload-button');

  /**
   * Determines whether the customer's current selections
   * result in a configuration with no glohe source.
   *
   * Warning conditions:
   *
   * Standard products:
   *   Remove Candle
   *   +
   *   LED Not Included / LEDs Not Included
   *
   * Sand Wax products:
   *   Remove Candle
   *   +
   *   Sand Wax Not Included
   *
   * Products without a "Remove Candle" option will never
   * trigger this warning.
   */
  function shouldShowNoGlowWarning(selectedLabels) {
    const normalizedLabels = selectedLabels.map(function (label) {
      return label.toLowerCase().trim();
    });

    const hasRemovedCandle = normalizedLabels.some(function (label) {
      return label.includes('remove candle');
    });

    const hasNoLed = normalizedLabels.some(function (label) {
      return (
        label === 'led not included' ||
        label === 'leds not included'
      );
    });

    const hasNoSandWax = normalizedLabels.some(function (label) {
      return label === 'sand wax not included';
    });

    return (
      hasRemovedCandle &&
      (hasNoLed || hasNoSandWax)
    );
  }

  /**
   * Displays the soft warning modal before allowing
   * the customer to continue to the customizer.
   */
  function showNoGlowWarning(onContinue) {
    const existingModal = document.querySelector(
      '.afterglohe-warning-modal'
    );

    if (existingModal) {
      existingModal.remove();
    }

    const modal = document.createElement('div');
    modal.className = 'afterglohe-warning-modal';

    modal.innerHTML = `
      <div class="afterglohe-warning-modal__overlay"></div>

      <div
        class="afterglohe-warning-modal__box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="afterglohe-warning-title"
      >
        <h2 id="afterglohe-warning-title">
          Continue Without a Glow?
        </h2>

        <p>
          Your current selections do not include a 'glohe' option
          for your keepsake.
        </p>

        <p>
          Afterglohe pieces are designed to softly illuminate
          your memories through light.
        </p>

        <p>
          Would you still like to continue?
        </p>

        <div class="afterglohe-warning-modal__actions">
          <button
            type="button"
            class="afterglohe-warning-modal__back"
          >
            Go Back
          </button>

          <button
            type="button"
            class="afterglohe-warning-modal__continue"
          >
            Continue Anyway
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal
      .querySelector('.afterglohe-warning-modal__back')
      .addEventListener('click', function () {
        modal.remove();
      });

    modal
      .querySelector('.afterglohe-warning-modal__overlay')
      .addEventListener('click', function () {
        modal.remove();
      });

    modal
      .querySelector('.afterglohe-warning-modal__continue')
      .addEventListener('click', function () {
        modal.remove();
        onContinue();
      });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const baseUrl = button.dataset.customizerBaseUrl;
      const productTitle = button.dataset.productTitle || '';

      if (!baseUrl) {
        return;
      }

      /**
       * Collect currently selected Shopify option values.
       */
      const selectedLabels = [];

      document.querySelectorAll('fieldset').forEach(function (fieldset) {
        const checkedInput = fieldset.querySelector(
          'input[type="radio"]:checked'
        );

        if (checkedInput) {
          selectedLabels.push(checkedInput.value.trim());
        }
      });

      document.querySelectorAll('select').forEach(function (select) {
        if (
          select.name &&
          select.name.indexOf('options') !== -1 &&
          select.value
        ) {
          selectedLabels.push(select.value.trim());
        }
      });

      /**
       * Resolve the selected Shopify variant.
       */
      const variantsScript = document.querySelector(
        '.customizer-product-variants'
      );

      let variantId = button.dataset.defaultVariantId || '';

      if (variantsScript) {
        try {
          const variants = JSON.parse(variantsScript.textContent);

          const matchedVariant = variants.find(function (variant) {
            return selectedLabels.every(function (selectedValue, index) {
              return variant.options[index] === selectedValue;
            });
          });

          if (matchedVariant) {
            variantId = matchedVariant.id;
          }
        } catch (error) {
          console.error(
            'Could not parse customizer variant data:',
            error
          );
        }
      }

      /**
       * Continue to Firebase customizer using the existing
       * variantId / product / returnUrl contract.
       */
      function continueToCustomizer() {
        const url = new URL(baseUrl);

        const returnUrl = new URL(window.location.href);

        returnUrl.searchParams.set(
          'afterglohe_return',
          'customizer'
        );

        returnUrl.searchParams.set(
          'open_cart',
          'true'
        );

        if (variantId) {
          url.searchParams.set('variantId', variantId);
        }

        if (productTitle) {
          url.searchParams.set('product', productTitle);
        }

        url.searchParams.set(
          'returnUrl',
          returnUrl.toString()
        );

        window.location.href = url.toString();
      }

      /**
       * Validate glohe selection before redirect.
       *
       * This is intentionally a soft warning:
       * customers may still continue without a glohe source.
       */
      if (shouldShowNoGlowWarning(selectedLabels)) {
        showNoGlowWarning(continueToCustomizer);
      } else {
        continueToCustomizer();
      }
    });
  });
});